import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../../utils/colors';
import { useRandomLinkColors } from '../../utils/useRandomLinkColors';
const Navigation = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <ul className="list-none space-y-4" data-id="element-546">
      <li className="flex" data-id="element-547">
        <span className="mr-2" data-id="element-548">↑</span>
        <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-549">
          About
        </Link>
      </li>
      <li className="flex" data-id="element-550">
        <span className="mr-2" data-id="element-551">↑</span>
        <Link to="/photographs" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-552">
          Photographs
        </Link>
      </li>
      <li className="flex" data-id="element-553">
        <span className="mr-2" data-id="element-554">↑</span>
        <Link to="/writing" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-555">
          Writing
        </Link>
      </li>
      <li className="flex" data-id="element-556">
        <span className="mr-2" data-id="element-557">↑</span>
        <Link to="/books" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-558">
          Books
        </Link>
      </li>
      <li className="flex" data-id="element-559">
        <span className="mr-2" data-id="element-560">↑</span>
        <Link to="/workshops" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-561">
          Workshops
        </Link>
      </li>
      <li className="flex" data-id="element-562">
        <span className="mr-2" data-id="element-563">↑</span>
        <Link to="/news" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-564">
          News
        </Link>
      </li>
      <li className="flex" data-id="element-565">
        <span className="mr-2" data-id="element-566">↑</span>
        <Link to="/contact" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-567">
          Contact
        </Link>
      </li>
    </ul>;
};
export default Navigation;